import _ from "lodash";
import { wealthProApi } from "../../redux/api";

const userEmailContactApiEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ["EmailContacts"]
}).injectEndpoints({
    endpoints: (builder) => ({
        fetchUserEmailContacts: builder.query({
            query: ({ userId, searchText = '', page, limit, sort, masterAccountIds = null }) => {
                let searchTextParam = searchText && searchText.length > 0 ? `searchText=${searchText}` : '';
                let sortParam = `${searchTextParam.length > 0 ? '&' : ''}sort=${sort ?? "ContactName, ContactEmailAddress"}`;
                let masterAccountIdsParam = masterAccountIds && Array.isArray(masterAccountIds) && masterAccountIds.length > 0
                    ? `&masterAccountIds=${_.join(masterAccountIds, '&masterAccountIds=')}`
                    : '';

                if (page || limit) {
                    return `api/clientdocuments/users/${userId}/emailcontacts?${searchTextParam}${sortParam}&page=${page ?? 1}&limit=${limit ?? 50}${masterAccountIdsParam}`;
                }

                return `api/clientdocuments/users/${userId}/emailcontacts?${searchTextParam}${sortParam}${masterAccountIdsParam}`;
            },
            providesTags: ['EmailContacts']
        }),
        patchUserEmailContact: builder.mutation({
            query: ({ id, operations }) => ({
                url: `api/clientdocuments/emailcontacts/${id}`,
                method: "PATCH",
                body: operations
            }),
            invalidatesTags: ["EmailContacts"]
        }),
        deleteUserEmailContact: builder.mutation({
            query: ({ id }) => ({
                url: `api/clientdocuments/emailcontacts/${id}`,
                method: "DELETE"
            })
        })
    })
});

export const {
    useFetchUserEmailContactsQuery,
    useLazyFetchUserEmailContactsQuery,
    useDeleteUserEmailContactMutation,
    usePatchUserEmailContactMutation
} = userEmailContactApiEndpoints;